<template>
    <div>
        <ReturnHeader header="ดูรายละเอียดสินค้า" :img_header="header_image" link_back="stock/storage/returnstorage"/>
        <Return_details/>
    </div>
</template>

<script>
    import ImageHeader from '@/assets/loupe.png'
    import ReturnHeader from "@/components/admin/stock/storage_return/header_return/ReturnHeader.vue";
    import Return_details from "@/components/admin/stock/storage_return/Return_details.vue";
    export default {
        name: "ReturnDetails",
        components: {
            Return_details,
            ReturnHeader
        },
        data() {
            return {
                header_image: ImageHeader
            }
        }
    }
</script>

<style scoped>

</style>
